(function () {
  'use strict';

  // One-time guard — Shopify's theme editor reloads sections, which can re-run
  // this IIFE and double-attach handlers. Skip if we've already initialized.
  if (window.__vkProductInit) return;
  window.__vkProductInit = true;

  // Gallery thumbnail swap
  document.querySelectorAll('[data-vk-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.dataset.full;
      var main = document.getElementById('vk-product-main-img');
      if (!main || !full) return;
      main.src = full;
      document.querySelectorAll('[data-vk-product-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // Variant picker → update price + variant id + button state
  var variantSelect = document.getElementById('vk-product-variant-id');
  var priceEl = document.getElementById('vk-product-price');
  var addBtn = document.querySelector('#vk-product-form button[name="add"]');
  var mobilePriceEl = document.querySelector('[data-vk-product-mobilebar] .price');

  document.querySelectorAll('[data-vk-product-option]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      if (!variantSelect) return;
      var selectedValues = [];
      document.querySelectorAll('[data-vk-product-option]').forEach(function (s) { selectedValues.push(s.value); });
      var match = null;
      Array.prototype.forEach.call(variantSelect.options, function (opt) {
        if (opt.textContent.trim() === selectedValues.join(' / ')) match = opt;
      });
      if (!match) return;
      variantSelect.value = match.value;
      if (priceEl) priceEl.textContent = match.dataset.price;
      if (mobilePriceEl) mobilePriceEl.textContent = match.dataset.price;
      if (addBtn) {
        var available = match.dataset.available === 'true';
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
        addBtn.classList.toggle('sold-out', !available);
      }
    });
  });

  // Tabs (desktop) and accordion (mobile) — same panels, different controls.
  // Keeps aria-selected (tabs) and aria-expanded (accordion) in sync.
  function activatePanel(key) {
    document.querySelectorAll('[data-vk-product-tab]').forEach(function (b) {
      var on = b.dataset.vkProductTab === key;
      b.classList.toggle('active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-vk-product-acc]').forEach(function (b) {
      var on = b.dataset.vkProductAcc === key;
      b.classList.toggle('active', on);
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-vk-product-panel]').forEach(function (p) {
      p.hidden = p.dataset.vkProductPanel !== key;
    });
  }

  document.querySelectorAll('[data-vk-product-tab]').forEach(function (btn) {
    btn.addEventListener('click', function () { activatePanel(btn.dataset.vkProductTab); });
  });
  document.querySelectorAll('[data-vk-product-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () { activatePanel(btn.dataset.vkProductAcc); });
  });

  // Mobile sticky add-to-cart bar — shows after scrolling past inline buy box
  var mobileBar = document.querySelector('[data-vk-product-mobilebar]');
  var inlineBuy = document.querySelector('#vk-product-form');
  if (mobileBar && inlineBuy && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        mobileBar.classList.toggle('visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(inlineBuy);
  }

  // Mobile sticky bar's Add-to-Cart proxies to the inline form's submit
  var mobileAdd = document.querySelector('[data-vk-product-mobile-add]');
  if (mobileAdd && inlineBuy) {
    mobileAdd.addEventListener('click', function () {
      var submitBtn = inlineBuy.querySelector('button[name="add"]');
      if (submitBtn && !submitBtn.disabled) submitBtn.click();
    });
  }
})();
